import Vue from "vue";
import VueRouter from "vue-router";
import RobotData from "../views/RobotData.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Robot Data",
    component: RobotData,
  },
  {
    path: "/harvest/:id",
    name: "Harvest",
    component: () =>
      import(/* webpackChunkName: "harvest" */ "../views/Harvest.vue"),
    props: true,
  },
  {
    path: "/spraying/:id",
    name: "Spraying",
    component: () =>
      import(/* webpackChunkName: "spraying" */ "../views/Spraying.vue"),
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    meta: {
      skipAuth: true,
    },
  },
  {
    path: "/mapping/:id",
    name: "Mapping",
    component: () =>
      import(/* webpackChunkName: "Mapping" */ "../views/Mapping.vue"),
    props: true,
  },
  {
    path: "/settings",
    name: "Settings",
    component: () =>
      import(/* webpackChunkName: "Settings" */ "../views/Settings.vue"),
  },
  {
    path: "/spraying-settings/:id",
    name: "SprayingSettings",
    component: () =>
      import(
        /* webpackChunkName: "SprayingSettings" */ "../views/SprayingSettings.vue"
      ),
    props: true,
  },
  {
    path: "/farms",
    name: "Greenhouses",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "farms" */ "../views/Farms.vue"),
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (!to.matched.some((record) => record.meta.skipAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    let loggedIn = localStorage.getItem("loggedIn");
    if (loggedIn != "true") {
      next({ name: "Login" });
    } else {
      next(); // go to wherever I'm going
    }
  } else {
    next(); // does not require auth, make sure to always call next()!
  }
});

export default router;
